import ShopType from "@/enum/ShopType";
import { InjectBaseModalProps } from "@/hooks/Modal/ModalStore";
import { Modal } from "antd";
import React from "react";

interface ChanelShopLoginModalProps extends InjectBaseModalProps {
    shopType: ShopType;
}

const ChanelShopLoginModal: React.FC<ChanelShopLoginModalProps> = function (props) {
    const { open, onCancel, shopType } = props;

    const isSupplier = [ShopType.CHANNEL_SHOP_DROPSHIP, ShopType.CHANNEL_SHOP_SUPPLIER].includes(shopType);

    return (
        <Modal footer={null} open={open} onCancel={onCancel} width={1114} styles={{ body: { padding: 0 } }}>
            <div className="pr">
                <img
                    className="w"
                    src={
                        isSupplier
                            ? "https://img.alicdn.com/imgextra/i2/54458674/O1CN01FodniM2DwkZ2SXCjt_!!54458674.png"
                            : "https://img.alicdn.com/imgextra/i3/54458674/O1CN01JyypAW2DwkZ1dNUGn_!!54458674.png"
                    }
                />

                <a
                    href={
                        isSupplier
                            ? "https://store.weixin.qq.com/supplier/servicemarket/myServices?status=0"
                            : "https://store.weixin.qq.com/shop/servicemarket/myServices?status=0"
                    }
                    className="pa"
                    style={{ top: "20%", left: isSupplier ? "37%" : "32%", cursor: "pointer" }}
                    target="_blank"
                >
                    <img
                        src="https://img.alicdn.com/imgextra/i2/54458674/O1CN01pNZqB62DwkGTpmnws_!!54458674.png"
                        alt=""
                    />
                </a>
            </div>
        </Modal>
    );
};

export default React.memo(ChanelShopLoginModal);
